<script setup lang="ts">
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';

const route = useRoute();
const router = useRouter();

const tabs = [
  { name: 'search', label: 'Search', icon: 'search' },
  { name: 'watchlist', label: 'Watchlist', icon: 'list' },
  { name: 'schedule', label: 'Schedule', icon: 'calendar' },
  { name: 'settings', label: 'Settings', icon: 'cog' },
] as const;

const active = computed(() => route.name as string);

function go(name: string): void {
  router.push({ name });
}
</script>

<template>
  <nav
    class="fixed bottom-0 inset-x-0 z-40 border-t border-line bg-bg/90 backdrop-blur safe-bottom"
  >
    <ul class="flex justify-around max-w-xl mx-auto">
      <li v-for="tab in tabs" :key="tab.name" class="flex-1">
        <button
          class="w-full flex flex-col items-center justify-center gap-1 py-2 text-xs font-medium transition"
          :class="active === tab.name ? 'text-accent-glow' : 'text-fg-muted hover:text-fg'"
          @click="go(tab.name)"
        >
          <svg
            class="w-6 h-6"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <template v-if="tab.icon === 'search'">
              <circle cx="11" cy="11" r="7" /><path d="m21 21-4.3-4.3" />
            </template>
            <template v-else-if="tab.icon === 'list'">
              <path
                d="M4 6h4l2-2h10v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6z"
              />
              <path d="M9 13h6M9 17h6" />
            </template>
            <template v-else-if="tab.icon === 'calendar'">
              <rect x="3" y="5" width="18" height="16" rx="2" />
              <path d="M16 3v4M8 3v4M3 11h18" />
            </template>
            <template v-else>
              <circle cx="12" cy="12" r="3" />
              <path
                d="M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1A1.7 1.7 0 0 0 4.6 9a1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z"
              />
            </template>
          </svg>
          <span>{{ tab.label }}</span>
        </button>
      </li>
    </ul>
  </nav>
</template>
